import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DsProgressCircleModule } from '@bmw-ds/components';

@Component({
  selector: 'cdf-loading-indicator',
  imports: [DsProgressCircleModule],
  template: `
    <ds-progress-circle [class.m-3x]="!noSpacing()" size="sm" />
    <ng-content />
  `,
  styleUrls: ['./loading-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingIndicatorComponent {
  readonly noSpacing = input(false, { transform: booleanAttribute });
}
